import { IQuickNotation } from '../Interfaces/IQuickNotation';
import { IAlertPermissions } from '../Interfaces/IAlertPermissions';
import { IUpdatePermissions } from '../Interfaces/IUpdatePermissions';
import { IEncouragementPermissions } from '../Interfaces/IEncouragementPermissions';

export const NotationWidgetMappingService = {
  mapQuickNotationToAlertPermission: function (
    record: IQuickNotation,
  ): IAlertPermissions {
    return {
      showAlerts: record.alertShowPermission,
      audience: record.alertAudiencePermission,
      additionalAudience: record.alertAddAudiencePermission,
      assignTo: record.alertAssignToPermission,
      occurenceDate: record.alertOccuranceDatePermission,
      categories: record.alertCategoryPermission,
      reasons: record.alertReasonPermission,
    };
  },
  mapQuickNotationToUpdatePermission: function (
    record: IQuickNotation,
  ): IUpdatePermissions {
    return {
      showUpdates: record.updateShowPermission,
      audience: record.updateAudiencePermission,
      additionalAudience: record.updateAddAudiencePermission,
      occurenceDate: record.updateOccurancePermission,
      categories: record.updateCategoryPermission,
      reasons: record.updateReasonPermission,
    };
  },
  mapQuickNotationToEncouragementPermission: function (
    record: IQuickNotation,
  ): IEncouragementPermissions {
    return {
      showEncouragements: record.encouragementShowPermission,
      audience: record.encouragementAudiencePermission,
    };
  },
  mapDataToQuickNotation: function (
    titleText: string,
    description: string,
    height: number,
    width: number,
    alertPermissions: IAlertPermissions,
    updatePermissions: IUpdatePermissions,
    encouragementPermissions: IEncouragementPermissions,
    id?: number,
    createdById?: string,
    createdOn?: string,
  ): IQuickNotation {
    return {
      id: id,
      createdById: createdById,
      createdOn: createdOn,
      titleText: titleText,
      description: description,
      height: height,
      width: width,
      updateShowPermission: updatePermissions.showUpdates,
      updateAudiencePermission: updatePermissions.audience,
      updateAddAudiencePermission: updatePermissions.additionalAudience,
      updateOccurancePermission: updatePermissions.occurenceDate,
      updateCategoryPermission: updatePermissions.categories,
      updateReasonPermission: updatePermissions.reasons,
      alertShowPermission: alertPermissions.showAlerts,
      alertAudiencePermission: alertPermissions.audience,
      alertAddAudiencePermission: alertPermissions.additionalAudience,
      alertAssignToPermission: alertPermissions.assignTo,
      alertOccuranceDatePermission: alertPermissions.occurenceDate,
      alertCategoryPermission: alertPermissions.categories,
      alertReasonPermission: alertPermissions.reasons,
      encouragementShowPermission: encouragementPermissions.showEncouragements,
      encouragementAudiencePermission: encouragementPermissions.audience,
    };
  },
};
